import script from "./individual-transfer-form.vue?vue&type=script&setup=true&lang=js"
export * from "./individual-transfer-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__